import { render } from "./odn-modal-languages.vue?vue&type=template&id=132bc3ba"
import script from "./odn-modal-languages.vue?vue&type=script&lang=js"
export * from "./odn-modal-languages.vue?vue&type=script&lang=js"

import "./odn-modal-languages.vue?vue&type=style&index=0&id=132bc3ba&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__